import api from '@/apis/di/payrollItemAPI.js';
import {usefilterActionCombo} from './filterActionCombo.js';

// Combo grid Loại cán bộ
export const usePayrollItemGrid = (comboboxDataRemote, comboboxLoadData) => {
  const {extendFilter} = usefilterActionCombo();
  // func call api lấy dữ liệu combo
  const onPayrollItemComboboxLoadData = (payload, row, column) => {
    payload.sort = 'payroll_item_code';
    let ors = [{Field: 'inactive', Operator: 'NULL'}];
    let extend = [{Field: 'inactive', Value: false, Ors: ors}];
    payload.filter = extendFilter(payload.filter, extend);
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField);
  };

  // func call api lấy dữ liệu combo
  const onPayrollItemColumnSalaryComboboxLoadData = (payload, row, column) => {
    payload.sort = 'payroll_item_code';
    payload.columns += ',column_data_type';
    let ors = [{Field: 'inactive', Operator: 'NULL'}];
    let extend = [{Field: 'inactive', Value: false, Ors: ors}];
    payload.filter = extendFilter(payload.filter, extend);
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField);
  };

  // config columns combo
  const payrollItemComboConfig = {
    data: comboboxDataRemote,
    columns: [],
    displayField: 'payroll_item_code',
    valueField: 'payroll_item_id',
    queryMode: 'remote',
    dropdownWidth: 500,
    comboboxLoadData: onPayrollItemComboboxLoadData,
  };

  // Sự kiện load combo trên grid
  return {payrollItemComboConfig, onPayrollItemComboboxLoadData, onPayrollItemColumnSalaryComboboxLoadData}; // trả về thêm để dùng chung cho cả combo không thuộc grid
};
